import { NavBar } from "../components/NavBar";
import { Footer } from "../components/Footer";

export function AcercaPage() {
  return (
    <div className="min-h-screen bg-white text-slate-800 flex flex-col">
      <NavBar isLogged={false} />

      <main className="flex-1">
        <section className="mx-auto max-w-5xl px-6 pt-12">
          <div className="text-center">
            <h1 className="text-2xl font-semibold text-slate-900">Acerca de nosotros</h1>
            <p className="mx-auto mt-3 max-w-2xl text-sm text-slate-600">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
              been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
              galley of type and scrambled it to make a type specimen book. It has survived not only five
              centuries.
            </p>
            <div className="mt-4 flex justify-center text-slate-400">⌄</div>
          </div>
        </section>

        <section className="mx-auto max-w-5xl px-6 py-12">
          <div className="grid items-center gap-10 md:grid-cols-[1.1fr_0.9fr]">
            <div className="text-center">
              <h2 className="text-lg font-semibold text-slate-900">Clientes Satisfechos</h2>
              <p className="mt-3 text-sm leading-6 text-slate-600">
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
              </p>
              <p className="mt-4 text-sm leading-6 text-slate-600">
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
              </p>
            </div>

            <div className="flex justify-center">
              <div className="grid grid-cols-2 gap-4">
                <div className="h-28 w-28 rounded-3xl bg-red-600" />
                <div className="h-28 w-28 rounded-2xl bg-red-600" />
                <div className="h-28 w-28 rounded-2xl bg-red-600" />
                <div className="h-28 w-28 rounded-2xl bg-sky-700" />
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-5xl px-6 pb-12">
          <div className="text-center grid items-center gap-10 md:grid-cols-[0.9fr_1.1fr]">
            <div className="flex justify-center md:order-1">
              <div className="grid grid-cols-2 gap-4">
                <div className="h-28 w-28 rounded-2xl bg-red-600" />
                <div className="h-28 w-28 rounded-2xl bg-red-600" />
                <div className="h-28 w-28 rounded-2xl bg-red-600" />
                <div className="h-28 w-28 rounded-2xl bg-red-600" />
              </div>
            </div>

            <div className="md:order-2">
              <h2 className="text-lg font-semibold text-slate-900">Comunidad</h2>
              <p className="mt-3 text-sm leading-6 text-slate-600">
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
              </p>
              <p className="mt-4 text-sm leading-6 text-slate-600">
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
              </p>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-5xl px-6 pb-16">
          <div className="text-center">
            <h2 className="text-lg font-semibold text-slate-900">Confía en nuestras cifras</h2>
          </div>

          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <div className="h-28 rounded-2xl bg-sky-700" />
            <div className="h-28 rounded-2xl bg-secondary" />
            <div className="flex h-28 items-center justify-center rounded-2xl bg-red-600 text-white">
              <div className="text-center">
                <p className="text-xs font-medium">Expertos</p>
                <p className="text-xs">Verificados</p>
              </div>
            </div>
            <div className="flex h-28 items-center justify-center rounded-2xl bg-sky-700 text-white">
              <div className="text-center">
                <p className="text-lg font-semibold">17</p>
                <p className="text-xs">Categorías</p>
              </div>
            </div>
            <div className="flex h-28 items-center justify-center rounded-2xl bg-secondary text-slate-700">
              <div className="text-center">
                <p className="text-xs font-semibold">Seguridad</p>
                <p className="text-xs">Garantizada</p>
              </div>
            </div>
            <div className="flex h-28 items-center justify-center rounded-2xl bg-slate-100 text-slate-700">
              <div className="text-center">
                <p className="text-xs font-semibold">Calidad</p>
                <p className="text-xs">de servicios</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
